export default __webpack_public_path__ + "static/media/eTrain.f02802d0.png";